import { render, staticRenderFns } from "./DatasetEditor.vue?vue&type=template&id=70391738&scoped=true"
import script from "./DatasetEditor.vue?vue&type=script&lang=js"
export * from "./DatasetEditor.vue?vue&type=script&lang=js"
import style0 from "./DatasetEditor.vue?vue&type=style&index=0&id=70391738&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70391738",
  null
  
)

export default component.exports